import React, { useState, useEffect } from 'react'

// import LazyLoad from 'react-lazy-load'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { Redirect, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { SimpleCarousel } from '.'
import { toggleMenu } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    Container,
    Meta,
    Title,
    devices,
    // colors,
} from '../Common'
import { Loading } from '../Global/Loading'

const ImageCard = ({ image, openModal }) => {
    return (
        <ImageContainer>
            <img src={image.image} alt={image.alt_text} onClick={openModal} />
        </ImageContainer>
    )
}


const PageView = () => {
    const { page, notFound, menu, menuOpen } = useSelector(state => state.content, shallowEqual)
    const { gallery, title } = page
    const dispatch = useDispatch()
    const [showLightBox, setShowLightBox] = useState(false)
    const [activeSlide, setactiveSlide] = useState(0)
    const { width } = useWindowSize()
    const mobile = width < 480

    const openMenu = () => dispatch(toggleMenu(!menuOpen))

    if (notFound) return <Redirect to='/' />

    const openModal = (i) => {
        setactiveSlide(i)
        setShowLightBox(true)
    }

    const closeModal = () => setShowLightBox(false)

    useEffect(closeModal, [page])

    return (
        <>
            <Meta page={page} />
            <PageContainer lightbox={showLightBox}>
                {gallery.length ?
                    showLightBox ?
                        <SimpleCarousel title={title} slides={gallery} close={closeModal} activeImage={activeSlide} mobile={mobile} />
                        :
                        <>
                            <Title fontSize={mobile ? 14 : 16}>{title}</Title>
                            <ImageList>
                                {gallery.map((image, i) => <ImageCard key={i} image={image} openModal={() => openModal(i)} />)}
                            </ImageList>
                        </>
                    : <Loading marginbottom={30} />}
            </PageContainer>
        </>
    )
}

const PageContainer = styled(Container)`
    ${({ lightbox }) => lightbox && `
        padding-left: 0;
        padding-right: 0;
    `}

    min-height: calc(100vh - 90px);
    @media ${devices.small} {
        min-height: 95vh;
    }
`

const ImageList = styled.div`
   column-count: 3;
   column-gap: 6px;

    img {
        width: 93%;
        height: auto;
        border: 7px solid white;
        cursor: pointer;
    }

    @media ${devices.small} {
        column-count: 2;
        column-gap: 6px;

        img {
            border-width: 3px;
        }
    }
`

const ImageContainer = styled.div`
    margin-bottom: 6px;

    @media ${devices.small} {
        
    }
`

export default PageView
